<div>
    <span style = "color:aliceblue" >{{ text }}</span>
</div>